<template>
  <div class="game-mz-coloring">
    <div :style="imageStyle">
      <canvas
        ref="canvasImage"
        class="coloring-canvas"
        @mousedown="clickOnCanvas"
        :width="startGameConfig.configGame.image.width"
        :height="startGameConfig.configGame.image.height"
      ></canvas>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mz-labyrinth',
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      stop: false,
      color: '#ffffff',
      colors: [],
      canvasImage: {},
      canvasImageData: new Uint8ClampedArray(),
      canvasTemplateImageData: new Uint8ClampedArray(),
      canvasMaskData: new Uint8ClampedArray(),
      imageStyle: {},
      paletteStyle: {},
    };
  },
  methods: {
    getImageSrc(imageSrc) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        let cnv = document.createElement('canvas'),
          img = new Image(),
          ctx = cnv.getContext('2d');
        cnv.width = this.startGameConfig.configGame.image.width;
        cnv.height = this.startGameConfig.configGame.image.height;
        img.src = this.getImageSrc(url);
        img.addEventListener('load', () => {
          ctx.drawImage(img, 0, 0);
        });
        img.onload = () =>
          resolve(
            ctx.getImageData(
              0,
              0,
              this.startGameConfig.configGame.image.width,
              this.startGameConfig.configGame.image.height
            )
          );
        img.onerror = () => reject(console.log('Error loading image'));
      });
    },
    hex2Rgb(hex) {
      return {
        r: (hex >> 16) & 0xff,
        g: (hex >> 8) & 0xff,
        b: hex & 0xff,
      };
    },
    clickOnCanvas(event) {
      let x = event.offsetX;
      let y = event.offsetY;
      let gray = this.canvasMaskData.data[y * this.startGameConfig.configGame.image.width * 4 + x * 4 + 1];
      this.fillShape(gray);
    },
    switchColor(color) {
      let newColor = this.color;
      if (color == newColor) {
        newColor = '#ffffff';
      }
      return newColor;
    },
    fillShape(gray) {
      let color = this.startGameConfig.configGame.image.colors[gray];
      if (color != '#000000' && !this.stop) {
        let switchedColor = this.switchColor(this.colors[gray - 1]);
        this.colors[gray - 1] = switchedColor;
        let newColor = this.hex2Rgb(parseInt(switchedColor.slice(1, 7), 16));
        for (
          let i = 0;
          i < this.startGameConfig.configGame.image.width * this.startGameConfig.configGame.image.height * 4;
          i += 4
        ) {
          if (this.canvasMaskData.data[i] == gray) {
            this.canvasImageData.data[i] = newColor.r;
            this.canvasImageData.data[i + 1] = newColor.g;
            this.canvasImageData.data[i + 2] = newColor.b;
          }
        }
        this.canvasImage.putImageData(this.canvasImageData, 0, 0);
      }
    },
    checkGameAction() {
      let isCorrect = true;
      for (let [i, e] of this.colors.entries()) {
        if (e.toLowerCase() != this.startGameConfig.configGame.image.colors[i + 1].toLowerCase()) {
          isCorrect = false;
          break;
        }
      }
      return isCorrect;
    },
    resetGameAction() {
      this.canvasImage.clearRect(
        0,
        0,
        this.startGameConfig.configGame.image.width,
        this.startGameConfig.configGame.image.height
      );
      this.canvasImage.putImageData(this.canvasTemplateImageData, 0, 0);
      this.canvasImageData = this.canvasImage.createImageData(
        this.startGameConfig.configGame.image.width,
        this.startGameConfig.configGame.image.height
      );
      this.canvasImageData.data.set(this.canvasTemplateImageData.data);
      this.colors.forEach((e, i) => {
        this.colors[i] = '#ffffff';
      });
      this.colors[0] = '#000000';
    },
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function(newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
  created() {
    this.loadImage(this.startGameConfig.configGame.image.srcMask).then((data) => {
      return (this.canvasMaskData = data);
    });
    this.loadImage(this.startGameConfig.configGame.image.srcImage).then((data) => {
      return (this.canvasImageData = data);
    });
    this.loadImage(this.startGameConfig.configGame.image.srcImage).then((data) => {
      return (this.canvasTemplateImageData = data);
    });
  },
  beforeMount() {
    this.imageStyle = this.startGameConfig.configGame.image.cssStyle;
  },
  mounted() {
    this.canvasImage = this.$refs.canvasImage.getContext('2d');
    let image = new Image();
    image.src = this.getImageSrc(this.startGameConfig.configGame.image.srcImage);
    image.addEventListener('load', () => {
      this.canvasImage.drawImage(image, 0, 0);
    });
    this.colors = Array.from(
      {
        length: Object.keys(this.startGameConfig.configGame.image.colors).length - 1,
      },
      () => '#ffffff'
    );
    this.colors[0] = '#000000';
    this.color = this.startGameConfig.configGame.image.mainColor;
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$backgroundWidth: 1906px;
$backgroundHeight: 900px;
$backgroundOffsetTop: 140px;
$backgroundOffsetLeft: 0;
.game-mz-coloring {
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  top: $backgroundOffsetTop;
  left: $backgroundOffsetLeft;
  height: $backgroundHeight;
  width: $backgroundWidth;
}
</style>
